import { useEffect } from 'react'
import { isBrowser } from '../utils/generic'
import { checkShowSEOContentStatus } from '../utils/checkShowSEOContentStatus'
import { useAppPathPrefix } from '../utils/getWebsiteUrl'

export const useNoIndex = (noindex, pageType, yoast) => {
  const renderSEOTags = checkShowSEOContentStatus()
  const robots = yoast?.yoast_head_json?.robots

  const shouldNotIndex = () => {
    if (useAppPathPrefix) return true
    if (!renderSEOTags) return true
    if (noindex) return true
    if (isBrowser() && pageType === 'sports') {
      const {
        location: { pathname },
      } = window
      const sportsMatchRegex = /\/[\w-]+\/[\d]{5,}/g
      return sportsMatchRegex.test(pathname)
    }
    return false
  }

  useEffect(() => {
    if (!isBrowser()) return

    window.addEventListener('kambi-notification', handleKambiRouteUpdate)

    return () =>
      window.removeEventListener('kambi-notification', handleKambiRouteUpdate)
  }, [])

  const handleKambiRouteUpdate = (event) => {
    const {
      detail: { name },
    } = event

    if (name === 'routeChange') {
      const metaRobotsElement = document.getElementById('meta-robots')

      if (metaRobotsElement){
        if (shouldNotIndex()) {
          metaRobotsElement.setAttribute('content', 'noindex, nofollow, noarchive')
          return
        } 
        metaRobotsElement.setAttribute('content', robots?.index || '')
      }
    }
  }

  const doNotIndex = shouldNotIndex()

  return { doNotIndex }
}
